import { EntDirectoryInfoName } from '../directoryInfoName'

export class EntVetProduct {
	id: number | null = null
	nameKy: string | null = null
	nameRu: string | null = null
	category?: {
		id: number | null
		nameRu: string | null
		nameKy: string | null
	} | null = null
	categoryId?: number | null = null
}
